/* istanbul ignore file */

import { Site } from '../../../models';

export class SiteDragDropSelectionModel {
    allItems: Site[] = [];
    availableItems: Site[] = [];
    selectedItems: Site[] = [];
}
